// src/pages/Mango/Mango.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MangoHero from "../../components/MangoHero/MangoHero";
import MangoCategories from "../../components/MangoCategories/MangoCategories";
import MangoModal from "../../components/MangoModal/MangoModal";
import { mangoHeroSlides } from "../../data/mangoData";
import { API_BASE_URL } from "../../config";
import { useShowMango } from "../../hooks/useShowMango";
import "./mango-page.css";

const Mango = () => {
  const navigate = useNavigate();
  const showMango = useShowMango();
  const [selectedMango, setSelectedMango] = useState(null);
  // Varieties used to be a hardcoded import - now admin-managed, so this
  // fetches the live catalog instead. Hero slides stay static marketing
  // copy, same as the homepage's own hero.
  const [varieties, setVarieties] = useState([]);
  const [loading, setLoading] = useState(true);

  // Not just hiding the nav links to this page - a bookmarked or shared
  // /mango link should stop working too once the section is turned off,
  // same as it never existed.
  useEffect(() => {
    if (!showMango) {
      navigate("/", { replace: true });
    }
  }, [showMango, navigate]);

  useEffect(() => {
    const fetchVarieties = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/mango`);
        setVarieties(response.data.varieties || []);
      } catch (error) {
        console.error("Error fetching mango varieties:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVarieties();
  }, []);

  const handleSelectMango = (mango) => {
    setSelectedMango(mango);
  };

  const closeModal = () => {
    setSelectedMango(null);
  };

  return (
    <>
      <Helmet>
        <title>Fresh Mangoes - Ekhoni Khabo</title>
        <meta
          name="description"
          content="Order premium quality mangoes - Himshagor, Amrapali, Fazli, Lengra. Fresh from the farm, delivered to your doorstep!"
        />
        <meta property="og:title" content="Fresh Mangoes - Ekhoni Khabo" />
        <meta
          property="og:description"
          content="Order premium quality mangoes delivered to your doorstep!"
        />
      </Helmet>

      <main className="mango-page">
        <MangoHero slides={mangoHeroSlides} />
        {loading ? (
          <p className="text-center text-gray-500 py-16">Loading mangoes…</p>
        ) : varieties.length === 0 ? (
          <p className="text-center text-gray-500 py-16">
            No mangoes in season right now - check back soon!
          </p>
        ) : (
          <MangoCategories
            categories={varieties}
            onSelectCategory={handleSelectMango}
          />
        )}
      </main>

      {selectedMango && (
        <MangoModal mango={selectedMango} closeModal={closeModal} />
      )}
    </>
  );
};

export default Mango;
